import { defineStore } from "pinia";

import { useSelectionStore } from "./selection";

export const usePanModeStore = defineStore("panMode", {
  state: () => ({
    active: false,
  }),
  actions: {
    toggle(active?: boolean) {
      if (active === undefined ? !this.active : active) {
        if (!useSelectionStore().isSelectingWithRect) {
          useSelectionStore().selecting = "click";
          this.active = true;
          return true;
        }
        return false;
      }

      useSelectionStore().selecting = "no";
      this.active = false;
    },
  },
});
